import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useDeleteExpense = (options?: UseMutationOptions<void, unknown, string>) => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation<void, unknown, string>(
    ['delete-expense', assetId],
    async (expenseId: string) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      const response = await expensesApi.expensesControllerRemove(expenseId, assetId);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['fetch-expenses', assetId]);
        queryClient.invalidateQueries('fetch-expense-balance');
        queryClient.invalidateQueries('fetch-expense-stats');
        queryClient.invalidateQueries({ queryKey: ['fetch-personal-wallet'] });
        trackEvent('Expense', 'delete');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
